function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var module;
// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import etask from '../../../util/etask.js';
import zutil from '../../../util/util.js';
var is_node = typeof module == 'object' && module.exports;
var pick_routes = (from, routes, opt) => {
  var r = from.filter(({
    path
  }) => {
    return routes.some(v => v instanceof RegExp ? v.test(path) : v == path);
  });
  return !opt ? r : r.map(v => _objectSpread(_objectSpread({}, v), opt));
};
var troubleshooting_route = {
  exact: true,
  ssr_force: true,
  component: '/www/hola/pub/support/troubleshooting.js',
  css: ['/www/hola/pub/css/support.css']
};
var legal_routes = [{
  path: '/legal',
  exact: true,
  component: '/www/hola/pub/pages/hola.org/legal.tsx',
  meta: {
    title: 'Legal - Hola',
    canonical_url: 'https://hola.org/legal'
  }
}, {
  path: '/legal/privacy',
  exact: true,
  component: '/www/hola/pub/pages/hola.org/legal/privacy.tsx',
  translation: {
    enabled: true,
    detect_by_country: true,
    white_list: ['en', 'es', 'ru', 'de', 'fr', 'he']
  },
  meta: {
    title: 'Hola | Privacy Policy. What Information We Collect',
    description: 'We are committed to safeguarding your privacy & ' + 'ensuring transparency in our data practices. Learn how we ' + 'handle your information & your rights as a user here.',
    canonical_url: 'https://hola.org/legal/privacy'
  }
}, {
  path: '/legal/sla_clean',
  exact: true,
  component: '/www/hola/pub/pages/hola.org/legal/sla.tsx',
  headless: true,
  footless: true,
  meta: {
    title: 'EULA - Hola'
  }
}, {
  path: '/legal/sla',
  exact: true,
  component: '/www/hola/pub/pages/hola.org/legal/sla.tsx',
  meta: {
    title: 'Hola | Our End User License Agreement (EULA)',
    description: 'Read our End User Licence Agreement (EULA) to ' + 'understand the terms & conditions of using our service. Click ' + 'now to learn more & get started with secure browsing!',
    canonical_url: 'https://hola.org/legal/sla'
  }
}];
var hp_meta = {
  title: 'Hola | Fast, Secure, and Reliable Proxy Unblocker & VPN',
  description: 'Wish you could access worldwide content anytime, anywhere? ' + 'With Hola you can! Experience uninterrupted content at the tip of ' + 'your fingers! Discover more.'
};
var raw_routes = [{
  path: '/',
  exact: true,
  translation: {
    enabled: true,
    detect_by_country: true,
    white_list: ['en', 'tr', 'es', 'ru']
  },
  ssr_force: true,
  opt: {
    show_timer: true,
    show_banner: true
  },
  component: '/www/hola/pub/homepage.js',
  meta: hp_meta
}, {
  path: '/sites',
  exact: true,
  opt: {
    show_timer: true,
    show_banner: true
  },
  component: '/www/hola/pub/homepage.js',
  translation: {
    enabled: true,
    detect_by_country: true
  },
  meta: hp_meta
}, {
  path: ['/welcome/start_browse', '/download_hola'],
  exact: true,
  component: '/www/hola/pub/homepage.js',
  translation: {
    enabled: true,
    detect_by_country: true
  },
  meta: hp_meta
}, {
  path: '/footer_frm',
  exact: true,
  headless: true,
  component: '/www/hola/pub/footer_frm.js',
  opt: {
    external_links: true
  },
  css: []
}, {
  path: '/support',
  exact: true,
  ssr_force: true,
  component: '/www/hola/pub/support.js',
  meta: {
    title: 'Hola | Get Help and Support',
    description: 'Don\'t let questions or problems with our service ' + 'hold you back. Get the answers you need & the help you deserve ' + 'with our support page! We\'re ready to assist you now.',
    canonical_url: 'https://hola.org/support'
  }
}, _objectSpread(_objectSpread({
  path: '/support/troubleshooting/ios'
}, troubleshooting_route), {}, {
  meta: {
    title: 'Hola | iOS Troubleshooting',
    description: 'Struggling with connectivity issues on your iOS ' + 'devices? Check out our solutions for resolving common problems ' + '& ensuring seamless access to your favorite websites.',
    canonical_url: 'https://hola.org/support/troubleshooting/ios'
  }
}), _objectSpread(_objectSpread({
  path: '/support/troubleshooting/android'
}, troubleshooting_route), {}, {
  meta: {
    title: 'Hola | Android Troubleshooting',
    description: 'Experiencing Android connectivity problems, proxy ' + 'server issues, or anything else? Discover how to troubleshoot ' + 'your device now to enjoy unrestricted browsing.',
    canonical_url: 'https://hola.org/support/troubleshooting/android'
  }
}), _objectSpread(_objectSpread({
  path: '/support/troubleshooting/smarttv'
}, troubleshooting_route), {}, {
  meta: {
    title: 'Hola | SmartTV Troubleshooting',
    description: 'Have you followed all our setup steps but still ' + 'can\'t establish a connection on your SmartTV? Keep calm and ' + 'check out our SmartTV troubleshooting solutions now.',
    canonical_url: 'https://hola.org/support/troubleshooting/smarttv'
  }
}), _objectSpread(_objectSpread({
  path: '/support/troubleshooting/appletv'
}, troubleshooting_route), {}, {
  meta: {
    title: 'Hola | Apple TV Troubleshooting',
    description: 'Are you excited to use Hola on your AppleTV, but ' + 'running into streaming issues? We got you! Check out our ' + 'troubleshooting page to learn our quick & easy fixes now!',
    canonical_url: 'https://hola.org/support/troubleshooting/appletv'
  }
}), _objectSpread(_objectSpread({
  path: '/support/troubleshooting/firetv'
}, troubleshooting_route), {}, {
  meta: {
    title: 'Hola | Fire TV Troubleshooting',
    description: 'Sick of dealing with streaming issues on your Fire ' + 'TV? Our troubleshooting page has got your back with solutions ' + 'to get you to your favorite shows in no time.',
    canonical_url: 'https://hola.org/support/troubleshooting/firetv'
  }
}), _objectSpread(_objectSpread({
  path: '/support/troubleshooting/windows'
}, troubleshooting_route), {}, {
  meta: {
    title: 'Hola | Windows Troubleshooting',
    description: 'Are you having trouble connecting to Hola on your ' + 'Windows device? Check out our troubleshooting page to discover ' + 'the easy solutions to your problems today.',
    canonical_url: 'https://hola.org/support/troubleshooting/windows'
  }
}), _objectSpread(_objectSpread({
  path: '/support/troubleshooting/mac'
}, troubleshooting_route), {}, {
  meta: {
    title: 'Hola | Mac Troubleshooting',
    description: 'Experiencing issues with Hola on your Mac device? Our ' + 'troubleshooting page has got easy-to-follow solutions to get ' + 'you back to unrestricted browsing. Learn more.',
    canonical_url: 'https://hola.org/support/troubleshooting/mac'
  }
}), _objectSpread(_objectSpread({
  path: '/support/troubleshooting/extension'
}, troubleshooting_route), {}, {
  meta: {
    title: 'Hola | Browser Extension Troubleshooting',
    description: 'Having trouble with Hola\'s browser extension? Learn ' + 'how to troubleshoot your issues & experience seamless ' + 'performance while accessing your favorite sites & content.',
    canonical_url: 'https://hola.org/support/troubleshooting/extension'
  }
}), _objectSpread(_objectSpread({
  path: ['/support/troubleshooting', '/support/troubleshooting/:platform']
}, troubleshooting_route), {}, {
  meta: {
    title: 'Hola | Troubleshooting & Support',
    description: 'Having trouble using our service? Discover quick & ' + 'easy solutions to common issues, & get back to browsing in ' + 'no time. Click now to start surfing the web with ease!',
    canonical_url: 'https://hola.org/support/troubleshooting'
  }
}), {
  path: '/support/billing',
  exact: true,
  ssr_force: true,
  component: '/www/hola/pub/support/billing.js',
  css: ['/www/hola/pub/css/support.css'],
  meta: {
    title: 'Hola | Help Center. Billing and Payments',
    description: 'Looking for answers to your billing questions? Discover ' + 'all you need to know about billing policies, payment options, ' + '& account management on our billing FAQ page.',
    canonical_url: 'https://hola.org/support/billing'
  }
}, {
  path: '/thank_you_old',
  exact: true,
  no_ssr: true,
  headless: true,
  footless: true,
  component: '/www/hola/pub/thank_you.js',
  css: ['/www/hola/pub/css/thank_you.css'],
  meta: {
    title: 'Thank you for going Premium - Hola'
  }
}, {
  path: '/software_attribution',
  exact: true,
  component: '/www/hola/pub/software_attribution.tsx',
  meta: {
    title: 'Open Source Software Attribution - Hola'
  }
}, {
  path: '/press_kit',
  exact: true,
  component: '/www/hola/pub/press_kit.js',
  meta: {
    title: 'Press kit - Hola',
    canonical_url: 'https://hola.org/media'
  }
}, {
  path: '/plus_setup',
  exact: true,
  no_ssr: true,
  component: '/www/hola/pub/plus_setup.js',
  css: ['/www/hola/pub/css/plus_setup.css'],
  meta: ({
    search
  }) => {
    var params = new URLSearchParams(search);
    var _Object$fromEntries = Object.fromEntries(params.entries()),
      platform = _Object$fromEntries.platform,
      version = _Object$fromEntries.version;
    if (platform == 'windows') {
      return {
        title: 'Hola | Hola Premium Windows Device Setup Guide',
        description: 'Set up Hola on your windows device easily with ' + 'our setup guide! Check out our step-by-step ' + 'instructions to unlock unlimited access to your ' + 'favorite content.',
        canonical_url: 'https://hola.org/plus_setup'
      };
    }
    if (platform == 'console' && version == 'ps4') {
      return {
        title: 'Hola | Setting up Hola Premium on PlayStation 4',
        description: 'Say goodbye to lag and hello to a faster, more ' + 'immersive gaming experience with Hola Premium on ' + 'PlayStation 4. Check out our setup guide to get ' + 'started today.',
        canonical_url: 'https://hola.org/plus_setup'
      };
    }
    if (platform == 'console' && version == 'xbox_one') {
      return {
        title: 'Hola | Setting up Hola Premium on Xbox One Today',
        description: 'Whether you\'re playing solo or with friends, ' + 'maximize your gaming potential with Hola Premium on ' + 'Xbox One. Discover our simple setup guide to get ' + 'started today.',
        canonical_url: 'https://hola.org/plus_setup'
      };
    }
    if (platform == 'console') {
      return {
        title: 'Hola | Setting up Hola Premium On Your Gaming Console',
        description: 'Ready to unlock the full potential of your ' + 'gaming console? Look no further than Hola. Check out ' + 'our setup guide to enjoy unlimited access to your ' + 'favorite games.',
        canonical_url: 'https://hola.org/plus_setup'
      };
    }
    if (platform == 'mac' && version == 'appletv') {
      return {
        title: 'Hola | Setting Up Hola Premium on Your Apple TV Guide',
        description: 'Want to setup Hola Premium on your Apple TV? ' + 'Our step-by-step setup guide will have you up and ' + 'running in no time. Start enjoying the benefits of ' + 'Hola Premium today.',
        canonical_url: 'https://hola.org/plus_setup'
      };
    }
    if (platform == 'mac') {
      return {
        title: 'Hola | Hola Premium MacOS Step-By-Step Setup Guide',
        description: 'Want to stream movies or browsing the web ' + 'unrestricted on your MacOS device? With Hola Premium ' + 'you can! Check out our setup guide to get started now.',
        canonical_url: 'https://hola.org/plus_setup'
      };
    }
    if (platform == 'router') {
      return {
        title: 'Hola | Setting Up Keenetic Ultra Router with Hola ' + 'Premium',
        description: 'Do you have a Keenetic Ultra router? Did you ' + 'know that you can set up Hola premium and access ' + 'restricted content from around the world? Read our ' + 'setup guide now.',
        canonical_url: 'https://hola.org/plus_setup'
      };
    }
    if (platform == 'smarttv' && version == 'philips') {
      return {
        title: 'Hola | Setting Up Hola Premium On Your Philips ' + 'SmartTV',
        description: 'Whether you\'re binging your favorite shows ' + 'or jamming out to the latest tunes, Hola Premium for ' + 'Phillips SmartTV has got you. Learn how to access ' + 'global content now.',
        canonical_url: 'https://hola.org/plus_setup'
      };
    }
    // XXX dmitriikup: URG request from noav to remove all Samsung
    // if (platform=='smarttv' && version=='samsung')
    // {
    //     return {
    //         title: 'Hola | Hola Premium Samsung SmartTV Step-By-Step '
    //             +'Setup Guide',
    //         description: 'Unlock the full potential of your Samsung '
    //          +'SmartTV with Hola Premium! Our step-by-step setup guide '
    //             +'will have you streaming all of your favorite content '
    //             +'in no time.',
    //         canonical_url: 'https://hola.org/plus_setup',
    //     };
    // }
    if (platform == 'smarttv') {
      return {
        title: 'Hola | Learn How to Set Up LG SmartTV with Hola ' + 'Premium',
        description: 'Want to enjoy unrestricted streaming on your ' + 'smart TV? Then go over our step-by-step instructions ' + 'to setting up Hola Premium on your LG SmartTV right now',
        canonical_url: 'https://hola.org/plus_setup'
      };
    }
    return {
      title: 'Hola Premium setup',
      canonical_url: 'https://hola.org/plus_setup'
    };
  }
}, {
  path: '/faq',
  exact: true,
  ssr_force: true,
  component: '/www/hola/pub/faq2.js',
  meta: {
    title: 'Frequently Asked Questions',
    description: 'Find answers to frequently asked questions about our ' + 'proxy unblocker. Our comprehensive FAQ page covers all you need ' + 'to streamline your experience with us:',
    canonical_url: 'https://hola.org/faq'
  }
}, {
  path: '/faq_ios',
  exact: true,
  ssr_force: true,
  component: '/www/hola/pub/faq_ios2.js',
  meta: {
    title: 'OS App Frequently Asked Questions',
    description: 'Unleash the full potential of our iOS app with our ' + 'expertly crafted FAQ page. Get quick & easy answers to all your ' + 'questions to enjoy seamless, secure browsing.',
    canonical_url: 'https://hola.org/faq_ios'
  }
}, {
  path: '/faq_mac',
  exact: true,
  ssr_force: true,
  component: '/www/hola/pub/faq_ios2.js',
  meta: {
    title: 'MacOS FAQ - Hola',
    canonical_url: 'https://hola.org/faq_mac'
  }
}, {
  path: '/faq_macos',
  exact: true,
  ssr_force: true,
  component: '/www/hola/pub/faq_ios2.js',
  meta: {
    title: 'MacOS FAQ - Hola',
    canonical_url: 'https://hola.org/faq_macos'
  }
}, {
  path: '/faq_billing',
  exact: true,
  ssr_force: true,
  component: '/www/hola/pub/faq_billing2.js',
  meta: {
    title: 'Hola | iPhone & iPad Frequently Asked Questions',
    description: 'Looking for answers to your pressing iPhone and iPad ' + 'questions? Discover all you need to know about using Hola on ' + 'your iOS device by checkout out our FAQ page.',
    canonical_url: 'https://hola.org/faq_billing'
  }
}, {
  path: '/access/my/settings',
  exact: true,
  no_ssr: true,
  footless: true,
  component: '/www/hola/pub/unblock_my_settings.js',
  css: ['/www/hola/pub/css/unblock_my_settings.css'],
  meta: {
    title: 'My Settings - Hola'
  }
}, {
  path: ['/access/popular', '/vpn/popular'],
  exact: true,
  ssr_force: true,
  component: '/www/hola/pub/unblock_popular2.js',
  css: ['/www/hola/pub/css/popular_sites.css'],
  meta: ({
    country_name
  }) => ({
    title: `Popular sites in ${country_name} - accessible using Hola`
  })
}, {
  path: ['/vpn/:country'],
  exact: true,
  ssr_force: true,
  component: '/www/hola/pub/pages/hola.org/vpn/country.tsx'
}, {
  path: '/access/popular/:country',
  exact: true,
  component: '/www/hola/pub/unblock_popular2.js',
  css: ['/www/hola/pub/css/popular_sites.css'],
  meta: ({
    country_name
  }) => ({
    title: `Popular sites in ${country_name} - accessible using Hola`
  })
}, {
  path: ['dazn.com'].map(d => [`/access/${d}`, `/access/www.${d}`, `/access/${d}/from/:country`, `/access/www.${d}/from/:country`]).flat(),
  exact: true,
  statusCode: 404,
  component: '/www/hola/pub/pages/hola.org/404.tsx'
}, {
  path: ['/access/:domain'],
  exact: true,
  component: '/www/hola/pub/pages/hola.org/unblock_domain2023.tsx',
  css: [],
  default_theme: 'hola2023',
  meta: ({
    unblock: u = {},
    canonical_url
  }) => ({
    title: `Access ${u.domain} from any country | ` + `Access ${u.domain} - Hola`,
    description: `Access ${u.domain} and other sites censored in ` + 'your country - Hola',
    og_title: `Hola app to access ${u.domain} ` + 'from many virtual locations',
    canonical_url
  })
}, {
  path: ['/access/:domain/from/:country'],
  exact: true,
  component: '/www/hola/pub/pages/hola.org/unblock_domain2023.tsx',
  css: [],
  default_theme: 'hola2023',
  meta: ({
    unblock: u = {},
    canonical_url
  }) => ({
    title: `Access ${u.domain} from any country | ` + `Access ${u.domain} - Hola`,
    description: `Access ${u.domain} and other sites censored in ` + 'your country - Hola',
    og_title: `Hola app to access ${u.domain} ` + 'from many virtual locations',
    canonical_url
  })
}, {
  path: ['/access/apk/:pkg'],
  exact: true,
  component: '/www/hola/pub/pages/hola.org/unblock_apk2023.tsx',
  css: [],
  default_theme: 'hola2023',
  meta: ({
    unblock: u = {},
    canonical_url
  }) => ({
    title: `Access this app from any country: ${u.pkg} – Hola for Android`,
    description: `Change country for ${u.pkg} and other Android apps – ` + 'Hola for Android',
    og_title: `Hola app to change country for ${u.pkg} ` + '(Android)',
    canonical_url
  })
}, {
  path: ['/ultra'],
  exact: true,
  no_ssr: true,
  headless: true,
  component: '/www/hola/pub/join_n.js',
  css: ['/www/hola/pub/css/join_n.css'],
  translation: {
    enabled: true,
    detect_by_country: true
  },
  meta: {
    title: 'Hola | Choose Your Premium Plan & Subscribe Today',
    description: 'Unlock a world of unrestricted browsing with Hola ' + 'Premium! Choose your plan & subscribe today to enjoy ' + 'unrestricted browsing on multiple devices today.'
  }
}, {
  path: ['/test_anycontent'],
  exact: true,
  headless: true,
  no_ssr: true,
  component: '/www/hola/pub/test_anycontent.js',
  meta: {
    title: 'Any content block test'
  }
}, {
  path: '/translate',
  exact: true,
  component: '/www/hola/pub/translate.js',
  meta: {
    title: 'Hola | Help Us to Help You! Translate Hola Today ',
    description: 'Linguists we want you! We\'re looking for help to ' + 'translate our site into different languages. So if you\'re ' + 'fluent in multiple languages, visit our site to learn all.',
    canonical_url: 'https://hola.org/translate'
  }
}, {
  path: '/firefox',
  exact: true,
  component: '/www/hola/pub/firefox.js',
  css: ['/www/hola/pub/css/ios.css'],
  meta: {
    title: 'Hola - Access worldwide content',
    canonical_url: 'https://hola.org/firefox'
  }
}, {
  path: '/ios',
  exact: true,
  component: '/www/hola/pub/ios.js',
  css: ['/www/hola/pub/css/ios.css'],
  meta: {
    title: 'Hola | iOS App. Download Today To Use Across iOS Devices',
    description: 'Want to enjoy seamless, fast, & private browsing on ' + 'your iOS device? Our app is the solution for you! Access ' + 'truly Worldwide content, stream online, & stay secure.',
    canonical_url: 'https://hola.org/ios'
  }
}, {
  path: '/iphone',
  exact: true,
  component: '/www/hola/pub/iphone.js',
  css: ['/www/hola/pub/css/ios.css'],
  meta: {
    title: 'Running Hola on IPhone - Hola',
    canonical_url: 'https://hola.org/iphone'
  }
}, {
  path: '/star_program',
  exact: true,
  component: '/www/hola/pub/star_program.js',
  meta: {
    title: 'The Hola $7,000 star developer program - Hola'
  }
}, {
  path: '/challenges',
  exact: true,
  component: '/www/hola/pub/challenges.js',
  meta: {
    title: 'Code Challenges – Hola - Hola'
  }
}, {
  path: '/installer_login_close',
  exact: true,
  component: '/www/hola/pub/installer_login_close.js',
  meta: {
    title: 'Login - Hola'
  }
}, {
  path: '/bext_login',
  exact: true,
  component: '/www/hola/pub/bext_login.js',
  no_ssr: true,
  footless: true,
  headless: true,
  meta: {
    title: 'Login - Hola'
  }
}, {
  path: '/download/rmt_upgrade',
  exact: true,
  component: '/www/hola/pub/download/rmt_upgrade2.tsx',
  no_ssr: true,
  css: [],
  default_theme: 'hola2023',
  nomenu: true,
  meta: {
    title: 'Hola – Download Hola for Windows, access global content',
    canonical_url: 'https://hola.org/download/rmt_upgrade'
  }
}, {
  path: ['/signin', '/signup'],
  exact: true,
  no_ssr: true,
  footless: true,
  headlogo: true,
  default_theme: 'hola2023',
  component: '/www/hola/pub/signin.js',
  meta: ({
    search
  }) => {
    var params = new URLSearchParams(search);
    var next_q = params.get('next');
    if (next_q && next_q.indexOf('embed_style_login') > -1) {
      return {
        title: 'Hola App'
      };
    }
    return {
      title: 'Hola | Sign in - Access Your Account Now',
      description: 'Want to access restricted websites & protect your ' + 'online privacy? Try out our proxy unblocker! Log in now to ' + 'enjoy unrestricted internet access & anonymous browsing.',
      canonical_url: 'https://hola.org/signin'
    };
  }
}, {
  path: '/change_password',
  exact: true,
  no_ssr: true,
  footless: true,
  component: '/www/hola/pub/change_password.js',
  css: ['/www/hola/pub/css/password.css'],
  meta: {
    title: 'Change password - Hola'
  }
}, {
  path: ['/dna', '/dna/:section', '/dna/:section/:sub'],
  exact: true,
  footless: true,
  ssr_force: true,
  component: '/www/hola/pub/dna.js',
  css: ['/www/hola/pub/css/dna.css'],
  meta: {
    title: 'Hola DNA'
  }
}, {
  path: '/email_unsubscribe',
  exact: true,
  no_ssr: true,
  footless: true,
  component: '/www/hola/pub/unsubscribe.js',
  css: ['/www/hola/pub/css/unsubscribe.css'],
  meta: {
    title: 'Unsubscribe'
  }
}, {
  path: '/test_unsubscribe',
  exact: true,
  no_ssr: true,
  footless: true,
  component: '/www/hola/pub/unsubscribe.js',
  css: ['/www/hola/pub/css/unsubscribe.css'],
  meta: {
    title: 'Unsubscribe'
  }
}, {
  path: '/refund',
  exact: true,
  no_ssr: true,
  footless: true,
  component: '/www/hola/pub/refund.js',
  css: ['/www/hola/pub/css/refund.css'],
  meta: {
    title: 'Refund - Hola'
  }
}, {
  path: '/vpn_settings',
  exact: true,
  no_ssr: true,
  headless: true,
  footless: true,
  component: '/www/hola/pub/vpn_settings.js',
  css: ['/www/hola/pub/css/vpn_settings.css'],
  meta: {
    title: 'Settings - Hola'
  }
}, {
  path: '/dns_setup',
  exact: true,
  no_ssr: true,
  footless: true,
  component: '/www/hola/pub/dns_setup.js',
  css: ['/www/hola/pub/css/dns_setup.css'],
  meta: {
    title: 'DNS Settings - Hola'
  }
}, {
  path: '/survey/:id',
  exact: true,
  no_ssr: true,
  footless: true,
  component: '/www/hola/pub/survey.tsx',
  meta: {
    title: 'Hola VPN Survey'
  }
}, {
  path: '/ads:id',
  exact: true,
  no_ssr: true,
  footless: true,
  component: '/www/hola/pub/pages/hola.org/ads.tsx',
  meta: {
    title: 'Hola VPN Ads'
  }
}, {
  path: '*',
  component: '/www/hola/pub/pages/hola.org/404.tsx'
}];
var raw_holavpn = [_objectSpread({}, raw_routes[0]), {
  path: '/ads:id',
  exact: true,
  no_ssr: true,
  footless: true,
  component: '/www/hola/pub/pages/holavpn/ads.tsx',
  meta: {
    title: 'Hola VPN Ads'
  }
}, ...legal_routes, ...raw_routes.slice(1).filter(r => r.path !== '/ads:id')];
var raw_holabrowser = [{
  path: '/',
  component: '/www/hola/pub/pages/holabrowser/index.tsx',
  exact: true,
  headlogo: true,
  footless: true,
  meta: {
    title: 'Hola Browser - Access Global Content',
    description: 'With our browser, you can easily access any website ' + 'from around the world! It\'s the ultimate solution for a truly ' + 'borderless experience. Get the Hola Browser.',
    canonical_url: 'https://holabrowser.com',
    og_url: 'https://holabrowser.com'
  },
  ssr_force: true,
  opt: {
    logo: 'logo_browser.png',
    navbar_with_lang: true
  },
  translation: {
    enabled: false,
    detect_by_country: true,
    white_list: ['en', 'tr', 'es', 'de', 'ja', 'fr']
  }
}, {
  path: '/faq',
  exact: true,
  ssr_force: true,
  component: '/www/hola/pub/faq2.js',
  meta: {
    title: 'FAQ - Hola',
    canonical_url: 'https://hola.org/faq'
  },
  headlogo: true,
  footless: true,
  br_footer: true
}, {
  path: '/legal/sla',
  exact: true,
  component: '/www/hola/pub/pages/hola.org/legal/sla.tsx',
  meta: {
    title: 'EULA - Hola'
  },
  headlogo: true,
  footless: true,
  br_footer: true
}, {
  path: '/legal/privacy',
  exact: true,
  component: '/www/hola/pub/pages/hola.org/legal/privacy.tsx',
  translation: {
    enabled: true,
    detect_by_country: true,
    white_list: ['en', 'es', 'ru', 'de', 'fr', 'he']
  },
  meta: {
    title: 'Privacy Policy - Hola'
  },
  headlogo: true,
  footless: true,
  br_footer: true
}, {
  path: '/ads:id',
  exact: true,
  no_ssr: true,
  footless: true,
  component: '/www/hola/pub/pages/holabrowser/ads.tsx',
  meta: {
    title: 'Hola VPN Ads'
  }
}, ...pick_routes(raw_routes, ['/contact', '/support', /\/support\/.+/], {
  headlogo: true,
  footless: true,
  br_footer: true
}), {
  path: '*',
  component: '/www/hola/pub/pages/hola.org/404.tsx',
  headlogo: true,
  footless: true
}];
var raw_holavpninstaller = [...legal_routes, ...raw_routes];
var raw_holavpnandroid = [...legal_routes, ...raw_routes];
var raw_haffnetwork = [{
  path: '*',
  component: '/www/hola/pub/pages/hola.org/404.tsx'
}];
export var routes_by_host = {
  'hola.org': raw_routes.slice(0, -1).concat({
    path: '*',
    component: '/www/hola/pub/pages/hola.org/404.tsx'
  }),
  'holavpn': raw_holavpn,
  'holabrowser': raw_holabrowser,
  'holavpninstaller.com': raw_holavpninstaller,
  'holafreevpn.com': raw_routes,
  'holavpnandroid.com': raw_holavpnandroid,
  'haffnetwork': raw_haffnetwork
};
var create_async_component = (module_path, r_object, Data_context) => {
  var _Async_component;
  var Component = null;
  return _Async_component = class Async_component extends React.Component {
    constructor() {
      super();
      this.state = {
        Component
      };
      var _this = this;
      etask(function* () {
        yield Async_component.load();
        _this.context.reset();
        if (_this.state.Component !== Component) _this.setState({
          Component
        });
      });
    }
    render() {
      if (this.state.Component) return /*#__PURE__*/React.createElement(this.state.Component, this.props);
      return /*#__PURE__*/React.createElement("div", {
        className: "component-preloader"
      });
    }
  }, _defineProperty(_Async_component, "contextType", Data_context), _defineProperty(_Async_component, "load", () => etask(function* () {
    var module;
    var module_name = module_path.replace('/www/hola/pub/', '');
    var et = etask.wait();
    import(/* webpackExclude: /Jakefile\.js$/ */
    /* webpackInclude: /((.*)\/pages\/(.*)|homepage|affiliate_lp|affiliate_marketing|affiliate|footer_frm|white_label|about|products|support|troubleshooting|billing|affiliate|thank_you|forgot_password|software_attribution|press_kit|plus_setup|faq2|faq_ios2|faq_billing2|check_your_email|my_account|unblock_my_settings|unblock_popular2|unblock_domain2|unblock_apk2|join_n|test_anycontent|translate|unverified_email_resend|unverified_email|firefox|ios|iphone|jobs|star_program|challenges|installer_login_close|installer_login|bext_login|rmt_upgrade_page|rmt_upgrade2|download|signin|change_password|set_password|reset_password|dna|unsubscribe|refund|vpn_settings|dns_setup|survey)\.(tsx|js)$/ */
    '/www/hola/pub/' + module_name).then(m_res => {
      module = m_res;
      et.continue();
    }).catch(e => {
      if (window.reload_on_chunk_error) location.reload();
    });
    yield et;
    Component = module.Root;
    Object.assign(r_object, Component.meta, {
      loaded: true
    });
    if (r_object && r_object.on_load) r_object.on_load();
  })), _Async_component;
};
var get_component = (route, opt, r_object, Data_context) => {
  if (is_node && route.no_ssr) return null;
  var comp = route.component;
  if (typeof comp != 'string') return comp;
  return is_node ? require('../../../' + comp).Root : create_async_component(comp, r_object, Data_context);
};
var app_routes = {};
export var get_app_routes = (App, opt, Data_context) => {
  var settings_conf = zutil.get(opt.www_hola, 'routes', {});
  var settings = settings_conf[opt.host] || settings_conf.default || {
    root: 'hola.org'
  };
  if (!app_routes[settings.root]) {
    app_routes[settings.root] = [];
    var r_by_host = routes_by_host[settings.root];
    var raw_routes_ = r_by_host.slice(0, r_by_host.length - 1).concat(opt.dynamic_routes || []).concat([r_by_host[r_by_host.length - 1]]);
    // XXX dmitriiz: move 404 page to the end
    raw_routes_.forEach(r => {
      var r_obj = Object.assign({}, r);
      if (r_obj.path == '*') r_obj.path = undefined;
      r_obj.component = get_component(r, opt, r_obj, Data_context);
      app_routes[settings.root].push(r_obj);
    });
  }
  var final = app_routes[settings.root];
  return [{
    component: App,
    routes: final.filter(r => !r.disabled || !r.disabled(opt))
  }];
};